import styled from "@emotion/styled";
import { Colors, FontWeight } from "@snapchat/snap-design-system";

export const ModalClose = styled.button`
    cursor: pointer;

    position: absolute;
    z-index: 10;
    top: 0;
    right: 0;

    padding: 0;

    font-weight: ${FontWeight.BOLD};
    line-height: 1;
    color: ${Colors.Gray.V300};
    text-decoration: none;

    background: transparent;
    border: 0;
    outline: 0;

    transition: color 0.3s;

    :focus,
    :hover {
        color: ${Colors.Black.V50};
        text-decoration: none;
    }
`;

export const ModalCloseX = styled.span`
    display: block;
    margin-top: 24px;
    margin-right: 24px;
`;
